import React from 'react';
import { t } from '../../../utils/i18n';

const ColorSelectWidget = (props) => {
    const { options, value, disabled, readonly, onChange } = props;

    // Colors injected via ui:options from the product API (full objects: { id, name, hex })
    const colorObjects = options?.colors || [];

    // Build a map from color name -> hex for quick lookup
    const hexByName = {};
    colorObjects.forEach(c => {
        if (c && c.name && c.hex) {
            hexByName[c.name] = c.hex;
        }
    });

    // Fallback map for legacy hardcoded color names
    const fallbackHex = {
        'Antraciet': '#383838',
        'Creme':     '#FFF8E7',
        'Zwart':     '#000000',
    };

    const getBackgroundColor = (optionValue) => {
        return hexByName[optionValue] || fallbackHex[optionValue] || '#CCCCCC';
    };

    return (
        <div className="darzo-customfield-color">
            {options.enumOptions.map((option, index) => (
                <label key={index} className="">
                    <input
                        type="radio"
                        value={option.value}
                        checked={value === option.value}
                        onChange={() => onChange(option.value)}
                        disabled={disabled || readonly}
                        className="hidden"
                    />
                    <div
                        className=""
                        style={{
                            backgroundColor: getBackgroundColor(option.value),
                            border: value === option.value ? '2px solid #3182ce' : '2px solid transparent',
                        }}
                    />
                    <span className="block">{t(option.label)}</span>
                </label>
            ))}
        </div>
    );
};

export default ColorSelectWidget;
